/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Input, OnChanges} from '@angular/core';

import {TARGETING_IMPORTS} from '../targeting-imports';

@Component({
  imports: TARGETING_IMPORTS,
  selector: 'adn-targeting-domain-summary',
  template: '<span><strong *ngIf="not">NOT </strong>{{data}}</span>'
})
export class DomainSummaryComponent implements OnChanges {
  @Input() targets: any;

  data = '';
  not = false;

  ngOnChanges(): void {
    const target = this.targets || {};
    this.data = (target.names || []).join(', ');
    this.not = target.negated;
  }
}
